import styled from 'styled-components'
export const MainContainer = styled.main<{ isCentered?: boolean }>`
    max-width: 1180px;
    height: 650px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;
    margin: 0 auto;
    justify-content: ${properties => (properties.isCentered ? 'center' : 'space-between')};
`
